import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import Creatable from "react-select/creatable";
import api from "api/api";

//Props Validations

//Material UI Components
import Button from "@mui/material/Button";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

// import mui icons
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

//import assets
import brandImg from "../../assets/brands.png";
import calendarImg from "../../assets/calendar.jpg";
import countryImg from "../../assets/country.jpeg";
import competitorImg from "../../assets/competitor.png";
import productImg from "../../assets/product.jpg";
import productNameImg from "../../assets/product-name.jpeg";
import studyRefImg from "../../assets/study-ref.jpeg";
import UploadProductImage from "../../assets/product-image.webp";
import studyTypeImg from "../../assets/study-type.png";
import studyTypeMethodImg from "../../assets/study-type-method.png";

// redux
import { useSelector } from "react-redux";

//import components
import AlertDialogue from "./AlertDialogue";
import Loader from "../common/Loader";
import SanityCheckDialogue from "./SanityCheckDialogue";
import MultiSelect from "../common/MultiSelect";
import ActionStandardTabs from "../actionStandards/ActionStandardTabs";
import ReactSelectStyles from "../../styles/ReactSelectStyles";
import ProductMetadataProductsListDialog from "./ProductMetadataProductsListDialog";

const Alert = React.forwardRef(function Alert(props, ref) {
    return (
        <MuiAlert
            elevation={6}
            ref={ref}
            variant="filled"
            {...props}
        />
    );
});

function UpdateDataSeeding() {
    // redux store data
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const productCategoryOptions = [
        {
            label: productCategoryData?.label || "",
            value: productCategoryData?.value || null,
        },
    ];

    const productCategoryOptionsDataDriven = [
        {
            label: productCategoryData?.label || "",
            value: productCategoryData?.value || null,
        },
    ];

    const [data, setData] = useState({
        productCategory: productCategoryOptions[0],
        studyType: null,
        studyTypeMethod: null,
        unileverBrand: null,
        competitorBrand: null,
        country: null,
        projectName: null,
        projectNameTitle: null,
        studyPeriod: null,
        sharepointLink: null,
        studyReference: null,
        studyReferenceTitle: null,
    });
    const [editData, setEditData] = useState({
        productCategory: null,
        studyType: null,
        studyTypeMethod: null,
        unileverBrand: [],
        competitorBrand: [],
        projectName: null,
        projectNameTitle: null,
        sharepointLink: null,
        studyReference: null,
        studyReferenceTitle: null,
    });

    const [coreData, setCoreData] = useState({});

    // dropdowns options variables
    // const [productCategoryOptions, setProductCategoryOptions] = useState([]);
    const [unileverBrandOptions, setUnileverBrandOptions] = useState([]);
    const [competitorBrandOptions, setCompetitorBrandOptions] = useState([]);

    //variables for dialogue
    const [openEditModal, setOpenEditModal] = useState(false);
    const [successDialogueOpen, setSuccessDialogueOpen] = useState(false);
    const [errorDialogueOpen, setErrorDialogueOpen] = useState(false);
    const [sanityCheckDialogOpen, setSanityCheckDialogOpen] = useState(false);
    const [actionStandardModal, setActionStandardModal] = useState(false);

    // variables
    const [showEdit, setShowEdit] = useState(false);

    // file details variable
    const [title, setTitle] = useState("");
    const [attachment, setAttachment] = useState(null);

    //loader variables
    const [isLoading, setIsLoading] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("Loading");
    const [errorMessage, setErrorMessage] = useState("");
    // const [isASPostLoading, setIsASPostLoading] = useState(false);
    // const [isASUpdateLoading, setIsASUpdateLoading] = useState(false);

    //sanity checks data variables
    const [redSanityChecks, setRedSanityChecks] = useState([]);
    const [yellowSanityChecks, setYellowSanityChecks] = useState([]);

    const [disabledDownload, setDisabledDownload] = useState(true);
    const [showActionStandard, setShowActionStandard] = useState(false);

    // Image upload dialog variable
    // const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [newCreatedCoreDataId, setNewCreatedCoreDataId] = useState(null);

    const [uploadedProducts, setUploadedProducts] = useState([]);

    //snackbar
    const [snackInfo, setSnackInfo] = useState(["error", "error"]);
    const [snackBarOpen, setSnackBarOpen] = useState(false);

    //auto fetch
    const [autoFetch, setAutoFetch] = useState(false);

    // data driven
    // dropdowns options variables
    // const [productCategoryOptionsDataDriven, setProductCategoryOptionsDataDriven] = useState([]);
    const [studyTypeOptionsDataDriven, setStudyTypeOptionsDataDriven] = useState([]);
    const [studyTypeMethodOptionsDataDriven, setStudyTypeMethodOptionsDataDriven] = useState([]);
    const [unileverBrandOptionsDataDriven, setUnileverBrandOptionsDataDriven] = useState([]);
    const [competitorBrandOptionsDataDriven, setCompetitorBrandOptionsDataDriven] = useState([]);
    const [countryOptionsDataDriven, setCountryOptionsDataDriven] = useState([]);
    const [studyPeriodOptionsDataDriven, setStudyPeriodOptionsDataDriven] = useState([]);
    const [studyReferenceOptionsDataDriven, setStudyReferenceOptionsDataDriven] = useState([]);
    const [projectNameOptionsDataDriven, setProjectNameOptionsDataDriven] = useState([]);

    const [disableUpdate, setDisableUpdate] = useState(true);

    // temporary edit data
    const [tempEditData, setTempEditData] = useState({});

    const [filters, setFilters] = useState({
        productCategory: productCategoryOptions[0],
        studyType: [],
        studyTypeMethod: [],
        unileverBrand: [],
        competitorBrand: [],
        country: [],
        projectName: [],
        studyPeriod: [],
        studyReference: [],
    });

    useEffect(() => {
        const flag = Object.keys(editData).every((key) => {
            // Skip validation for studyType and studyTypeMethod since they're read-only
            if (key === "studyType" || key === "studyTypeMethod") return true;
            const value = editData[key];
            // Check if the value is an array
            if (Array.isArray(value)) {
                return value.length > 0; // Array should not be empty
            }

            // For non-array values, check if it's not empty or falsy
            return value !== null && value !== undefined && value !== "";
        });

        if (flag) {
            setDisableUpdate(false); // Enable update button
        } else {
            setDisableUpdate(true); // Disable update button
        }
    }, [editData]);

    useEffect(() => {
        function transformData(data) {
            return data.map((datum) => ({
                value: datum.id,
                label: datum.title,
            }));
        }

        function buildUrl(url, productCategoryId) {
            return productCategoryId ? `${url}?product_category=${productCategoryId}` : url;
        }

        function handleFetchError(error) {
            console.error("Error", error);
        }

        async function fetchUnileverBrandData() {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/core-data-models/data-driven/unilever-brands/`;
            const url = buildUrl(baseUrl, productCategoryId);

            try {
                const res = await api.get(url);
                const data = Array.isArray(res.data) ? res.data : [];
                const options = transformData(data);
                setUnileverBrandOptions(options);
            } catch (error) {
                handleFetchError(error);
            }
        }
        async function fetchCompetitorBrandData() {
            const baseUrl = process.env.REACT_APP_SERVER_PATH + `/core-data-models/data-driven/competitor-brands/`;
            const url = buildUrl(baseUrl, productCategoryId);

            try {
                const res = await api.get(url);
                const data = Array.isArray(res.data) ? res.data : [];
                const options = transformData(data);
                setCompetitorBrandOptions(options);
            } catch (error) {
                handleFetchError(error);
            }
        }

        fetchUnileverBrandData();
        fetchCompetitorBrandData();
    }, [autoFetch, productCategoryId]);

    // data driven
    useEffect(() => {
        const payload = {
            productCategory: `${productCategoryId}`,
            studyType: "", // NEW: Added studyType
            studyTypeMethod: "", // NEW: Added studyTypeMethod
            unileverBrand: "",
            competitorBrand: "",
            country: "",
            projectName: "",
            studyPeriod: "",
            studyReference: "",
        };
        const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/data-filter/`;
        api.post(url, payload)
            .then((res) => {
                if (Object.keys(res.data).length > 0) {
                    for (const key in res.data) {
                        let temp = res.data[key]?.map((datum) => {
                            if (key === "study_type_method") {
                                return {
                                    value: datum.id,
                                    label: datum.title,
                                    htmlLabel: formatDropdownOption(datum.title, datum.study_type__title),
                                };
                            } else {
                                return {
                                    value: datum.id,
                                    label: datum.title,
                                };
                            }
                        });
                        // if (key === "product_category") {
                        //     setProductCategoryOptionsDataDriven(temp);
                        // } else
                        if (key === "study_type") {
                            temp.sort((a, b) => b.label.localeCompare(a.lable));
                            setStudyTypeOptionsDataDriven(temp);
                        } else if (key === "study_type_method") {
                            setStudyTypeMethodOptionsDataDriven(temp);
                        } else if (key === "unilever_brands") {
                            setUnileverBrandOptionsDataDriven(temp);
                        } else if (key === "competitor_brands") {
                            setCompetitorBrandOptionsDataDriven(temp);
                        } else if (key === "country") {
                            setCountryOptionsDataDriven(temp);
                        } else if (key === "study_period") {
                            setStudyPeriodOptionsDataDriven(temp);
                            // }
                        } else if (key === "project_name") {
                            setProjectNameOptionsDataDriven(temp);
                        } else {
                            setStudyReferenceOptionsDataDriven(temp);
                        }
                    }
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                setErrorMessage(error);
                setErrorDialogueOpen(true);
                console.error(error);
            });
    }, [autoFetch, productCategoryId]);

    const handleInputChange = useCallback((e, name) => {
        let _newValue = null;
        if (name === "sharepointLink" || name === "projectNameTitle" || name === "studyReferenceTitle") {
            _newValue = e.target.value;
        } else {
            _newValue = e;
        }

        setData((prevState) => ({
            ...prevState,
            [name]: _newValue,
        }));
        setEditData((prevState) => ({
            ...prevState,
            [name]: _newValue,
        }));
    }, []);

    const handleCreateNewOptions = async (inputValue, name) => {
        const payload = {
            title: inputValue,
            description: inputValue,
        };

        let url = process.env.REACT_APP_SERVER_PATH;
        if (name === "unileverBrand") {
            url += `/unilever-brands/`;
        } else if (name === "competitorBrand") {
            url += `/competitor-brands/`;
        } else if (name === "studyReference") {
            url += `/study-references/`;
        } else if (name === "studyPeriod") {
            url += `/study-periods/`;
        } else if (name === "projectName") {
            url += `/project-names/`;
        }
        try {
            await api
                .post(url, payload)
                .then(async (res) => {
                    const data = {
                        value: res.data.id,
                        label: res.data.title,
                    };
                    if (name === "unileverBrand") {
                        setUnileverBrandOptions([data, ...unileverBrandOptions]);
                        setEditData((prevState) => ({
                            ...prevState,
                            [name]: [...prevState[name], data],
                        }));
                    } else if (name === "competitorBrand") {
                        setCompetitorBrandOptions([data, ...competitorBrandOptions]);
                        setEditData((prevState) => ({
                            ...prevState,
                            [name]: [...prevState[name], data],
                        }));
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    const formatDropdownOption = (title, studyTypeTitle) => {
        if (studyTypeTitle) {
            const textColor = studyTypeTitle.toLowerCase() === "home use test" ? "#005eef" : "#4CAF50";
            return (
                <div>
                    <span>{title}</span>
                    <span style={{ color: textColor }}>{` (${studyTypeTitle})`}</span>
                </div>
            );
        } else {
            return (
                <div>
                    <span>{title}</span>
                </div>
            );
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateAttachmentRequirement()) {
            return;
        }

        const formData = prepareFormData();
        const config = { headers: { "content-type": "multipart/form-data" } };

        setOpenEditModal(false);
        setLoaderMessage("Uploading");
        setIsLoading(true);

        try {
            const response = await api.put(`${process.env.REACT_APP_SERVER_PATH}/core-data-models/new/${coreData.id}/`, formData, config);

            const success = handleResponse(response.data);
            handleReset();

            if (success) {
                await runCronJob();
            }

            setAutoFetch(!autoFetch);
        } catch (error) {
            handleSubmissionError(error);
        }
    };

    const validateAttachmentRequirement = () => {
        if (editData.unileverBrand.length === tempEditData.unileverBrand.length && editData.competitorBrand.length === tempEditData.competitorBrand.length) {
            const brandsChanged = ["unileverBrand", "competitorBrand"].some((datum) => {
                const editValues = editData[datum].map((item) => item.value).sort((a, b) => b - a);
                const tempValues = tempEditData[datum].map((item) => item.value).sort((a, b) => b - a);
                return !editValues.every((value, index) => value === tempValues[index]);
            });

            if (brandsChanged && !attachment) {
                showErrorSnackbar("Please choose a file");
                return false;
            }
        } else if (!attachment) {
            showErrorSnackbar("Please choose a file");
            return false;
        }
        return true;
    };

    const prepareFormData = () => {
        const formData = new FormData();

        if (attachment) {
            formData.append("attachment", attachment);
            formData.append("title", title);
            formData.append("seeding_log", "Update:User:File updated by user");
        } else {
            formData.append("seeding_log", "Update:User:Entries updated by user");
        }
        // Append all fields
        appendFormField(formData, "product_category", editData.productCategory?.value);
        appendFormField(formData, "project_name", editData.projectName?.value);
        appendFormField(formData, "share_point_link", editData.sharepointLink);
        appendFormField(formData, "project_name_title", editData.projectNameTitle);
        appendFormField(formData, "study_reference_title", editData.studyReferenceTitle);
        appendFormField(formData, "study_type", editData.studyType?.value);
        appendFormField(formData, "study_type_method", editData.studyTypeMethod?.value);
        appendFormField(formData, "study_reference", editData.studyReference?.value);

        // Append brand arrays
        appendBrandArray(formData, "unilever_brands", editData.unileverBrand);
        appendBrandArray(formData, "competitor_brands", editData.competitorBrand);

        return formData;
    };

    const appendFormField = (formData, key, value) => {
        formData.append(key, value || "");
    };

    const appendBrandArray = (formData, key, brands) => {
        brands?.forEach((item) => formData.append(key, item.value));
    };

    const handleResponse = (data) => {
        if (data.red) setRedSanityChecks([...data.red]);
        if (data.yellow) setYellowSanityChecks([...data.yellow]);

        const validationFailed = data.red?.length && data.yellow?.length;

        if (validationFailed) {
            setErrorMessage("Oh No! Validation Failed!");
            setErrorDialogueOpen(true);
        } else {
            setSuccessDialogueOpen(true);
        }

        return !validationFailed;
    };

    const runCronJob = async () => {
        try {
            await api.get(`${process.env.REACT_APP_SERVER_PATH}/crons/run/`);
        } catch (error) {
            console.error("Cron job failed:", error);
        }
    };

    const handleSubmissionError = (error) => {
        setIsLoading(false);

        if (error?.response?.data?.error) {
            handleSanityCheckErrors(error.response.data.error);
        } else {
            const errorMessage = error.response?.data?.attachment?.join(" ") || error.response?.data?.title?.join(" ") || error.message;
            showErrorSnackbar(errorMessage);
        }

        console.error("Submission error:", error);
    };

    const handleSanityCheckErrors = (errorData) => {
        if (errorData.red) setRedSanityChecks([...errorData.red]);
        if (errorData.yellow) setYellowSanityChecks([...errorData.yellow]);
        setErrorMessage("Oh No! Validation Failed!");
        setErrorDialogueOpen(true);
    };

    const showErrorSnackbar = (message) => {
        setSnackInfo(["error", message]);
        setSnackBarOpen(true);
    };

    const handleReset = () => {
        setData({
            ...data,
            // productCategory: null,
            unileverBrand: null,
            competitorBrand: null,
            country: null,
            projectName: null,
            studyPeriod: null,
            sharepointLink: null,
            studyReference: null,
            studyReferenceTitle: null,
            projectNameTitle: null,
        });

        setFilters({
            ...filters,
            // productCategory: [],
            studyType: [],
            studyTypeMethod: [],
            unileverBrand: [],
            competitorBrand: [],
            country: [],
            projectName: [],
            studyPeriod: [],
            studyReference: [],
        });
        setDisabledDownload(true);
        setShowActionStandard(false);

        setEditData({
            productCategory: null,
            unileverBrand: null,
            competitorBrand: null,
            country: null,
            projectName: null,
            // studyPeriod: null,
            sharepointLink: null,
            studyReference: null,
            studyReferenceTitle: null,
            projectNameTitle: null,
        });
        setTitle("");
        setAttachment(null);
        setShowEdit(false);
        setAutoFetch(true);
        setUploadedProducts([]);
        setNewCreatedCoreDataId(null);
    };

    const handleSuccessClose = () => {
        setSuccessDialogueOpen(false);
    };

    const handleErrorClose = () => {
        handleSanityCheckDialogueGoBackButtonClick();
        setErrorDialogueOpen(false);
    };

    const handleSanityCheckDialogueGoBackButtonClick = async () => {
        const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/new/${coreData.id}/`;
        const payload = {
            go_back: true,
            seeding_log: "Update:User:File update attempted by user,Go Back",
        };
        try {
            await api
                .patch(url, payload)
                .then(async () => {})
                .catch((error) => {
                    console.error(error);
                });
        } catch (error) {
            console.error(error);
        }
    };

    const handleSanityCheckDialogue = () => {
        setSanityCheckDialogOpen(!sanityCheckDialogOpen);
    };

    const handleSanityCheckClose = () => {
        setSanityCheckDialogOpen(false);
    };

    const changeHandler = (e) => {
        if (e.target.files?.[0]) {
            setAttachment(e.target.files[0]);
            setTitle(e.target.files[0].name);
        }
    };

    const handleSnackBarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackBarOpen(false);
    };

    const handleSanityCheckDialogueUpdateButtonClick = async () => {
        const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/new/${coreData.id}/`;
        const payload = {
            parsed: false,
            archive: false,
            force_proceed: true,
            seeding_log: "Update:User:Validation Failed,Proceded by User",
        };
        try {
            await api
                .patch(url, payload)
                .then(async (res) => {
                    setIsLoading(false);
                    const data = res.data;
                    const ulPro = res.data.products;
                    const comPro = res.data.competitor_products;
                    const pro = [...ulPro, ...comPro];

                    setUploadedProducts(
                        pro.map((datum) => {
                            return {
                                productCode: datum,
                                imageData: null,
                                imagePath: null,
                                imageTitle: "",
                            };
                        })
                    );
                    setNewCreatedCoreDataId(res.data.id);
                    if (data.red !== undefined && data?.red.length !== 0) {
                        setRedSanityChecks([...data.red]);
                    }
                    if (data.yellow !== undefined && data?.yellow.length !== 0) {
                        setYellowSanityChecks([...data.yellow]);
                    }
                    if (data.red !== undefined && data.yellow !== undefined && data?.red.length !== 0 && data?.yellow.length !== 0) {
                        setErrorMessage("Oh No! Validation Failed!");
                        setErrorDialogueOpen(true);
                    } else {
                        setSuccessDialogueOpen(true);
                        setErrorDialogueOpen(false);
                    }
                    setSanityCheckDialogOpen(false);

                    handleReset();
                    try {
                        await api
                            .get(process.env.REACT_APP_SERVER_PATH + `/crons/run/`)
                            .then(() => {})
                            .catch((error) => {
                                console.error("Error", error);
                            });
                    } catch (error) {
                        console.error("Error", error);
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    setSanityCheckDialogOpen(false);
                    setErrorDialogueOpen(false);
                    if (error && error.response && error.response.data && error.response.data.length !== 0 && error.response.data.error) {
                        if (error.response.data.error?.red) {
                            setRedSanityChecks([...error.response.data.error.red]);
                        }
                        if (error.response.data.error?.yellow) {
                            setYellowSanityChecks([...error.response.data.error.yellow]);
                        }
                        setErrorMessage("Oh No! Validation Failed!");
                        setErrorDialogueOpen(true);
                    } else if (error.response.data.attachment) {
                        let str = error.response.data.attachment?.join(" ");
                        setSnackInfo(["error", str]);
                        setSnackBarOpen(true);
                    } else if (error.response.data.title) {
                        let str = error.response.data.title?.join(" ");
                        setSnackInfo(["error", str]);
                        setSnackBarOpen(true);
                    } else {
                        setSnackInfo(["error", error.message]);
                        setSnackBarOpen(true);
                    }
                });
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setSanityCheckDialogOpen(false);
            setErrorDialogueOpen(false);
            if (error && error.response && error.response.data && error.response.data.length !== 0 && error.response.data.error) {
                if (error.response.data.error?.red) {
                    setRedSanityChecks([...error.response.data.error.red]);
                }
                if (error.response.data.error?.yellow) {
                    setYellowSanityChecks([...error.response.data.error.yellow]);
                }
                setErrorMessage("Oh No! Validation Failed!");
                setErrorDialogueOpen(true);
            } else if (error.response.data.attachment) {
                let str = error.response.data.attachment?.join(" ");
                setSnackInfo(["error", str]);
                setSnackBarOpen(true);
            } else if (error.response.data.title) {
                let str = error.response.data.title?.join(" ");
                setSnackInfo(["error", str]);
                setSnackBarOpen(true);
            } else {
                setSnackInfo(["error", error.message]);
                setSnackBarOpen(true);
            }
        }
    };

    const handleStudyReference = async (e, name) => {
        setIsLoading(true)
        await setData((previousState) => {
            if (name === "projectName") {
                return {
                    ...previousState,
                    projectName: e,
                };
            } else {
                setShowActionStandard(true);
                return {
                    ...previousState,
                    studyReference: e,
                };
            }
        });
        await setEditData((previousState) => {
            if (name === "projectName") {
                return {
                    ...previousState,
                    projectName: e,
                };
            } else {
                return {
                    ...previousState,
                    studyReference: e,
                };
            }
        });

        try {
            let url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/`;
            if (name === "projectName") {
                url += `?project_name=${e.value}`;
            } else {
                url += `?study_reference=${e.value}`;
            }

            await api
                .get(url)
                .then(async (res) => {
                    if (res.data.length !== 0) {
                        setCoreData(res.data[0]);
                        setDisabledDownload(false);
                        const _productCategory = productCategoryOptionsDataDriven.filter((ele) => ele.value === res.data[0].product_category)[0];
                        const _studyType = studyTypeOptionsDataDriven.filter((ele) => ele.value === res.data[0].study_type)[0];
                        const _studyTypeMethod = studyTypeMethodOptionsDataDriven.filter((ele) => ele.value === res.data[0].study_type_method)[0];
                        const _unileverBrand = unileverBrandOptionsDataDriven.filter((ele) => res.data[0].unilever_brands.includes(ele.value));
                        const _competitorBrand = competitorBrandOptionsDataDriven.filter((ele) => res.data[0].competitor_brands.includes(ele.value));
                        const _country = countryOptionsDataDriven.filter((ele) => ele.value === res.data[0].country)[0];
                        const _projectName = projectNameOptionsDataDriven.filter((ele) => ele.value === res.data[0].project_name)[0];
                        const _studyReference = studyReferenceOptionsDataDriven.filter((ele) => ele.value === res.data[0].study_reference)[0];
                        const sharepointLink = res.data?.[0]?.share_point_link;
                        const projectNameTitle = res.data?.[0]?.project_name__title;
                        const studyReferenceTitle = res.data?.[0]?.study_reference__title;
                        const _coreData = {
                            productCategory: _productCategory,
                            studyType: _studyType,
                            studyTypeMethod: _studyTypeMethod,
                            unileverBrand: _unileverBrand,
                            competitorBrand: _competitorBrand,
                            country: _country,
                            // studyPeriod: _studyPeriod,
                            sharepointLink: sharepointLink,
                            projectNameTitle: projectNameTitle,
                            studyReferenceTitle: studyReferenceTitle,
                        };

                        if (name === "projectName") {
                            setShowActionStandard(true);
                            setData((previousState) => {
                                return {
                                    ...previousState,
                                    ..._coreData,
                                    studyReference: _studyReference,
                                };
                            });
                            setEditData((previousState) => {
                                return {
                                    ...previousState,
                                    ..._coreData,
                                    studyReference: _studyReference,
                                };
                            });
                        } else {
                            setData((previousState) => {
                                return {
                                    ...previousState,
                                    ..._coreData,
                                    projectName: _projectName,
                                };
                            });
                            setEditData((previousState) => {
                                return {
                                    ...previousState,
                                    ..._coreData,
                                    projectName: _projectName,
                                };
                            });
                        }

                        const ulPro = res.data[0].products;
                        const comPro = res.data[0].competitor_products;
                        const pro = [...ulPro, ...comPro];
                        // const __pro = [];
                        // for (const p of pro) {
                        //     const imageUrl = process.env.REACT_APP_SERVER_PATH + `/product-images/?core_data_model=${res.data[0].id}&title=${encodeURIComponent(p)}`;
                        //     const imageBaseUrl = process.env.REACT_APP_MEDIA_PATH;
                        //     try {
                        //         api.get(imageUrl)
                        //             .then(async (res) => {
                        //                 if (res.data.length !== 0 && res.data[0].product_images.split("filestorage").length !== 0) {
                        //                     const _imagePath = imageBaseUrl + res.data[0].product_images.split(".unilever.com")[1];
                        //                     let obj = {
                        //                         id: res.data[0].id,
                        //                         productCode: p,
                        //                         imageData: _imagePath,
                        //                         imagePath: _imagePath,
                        //                         imageTitle: res.data[0].description,
                        //                         isCompetitor: comPro.includes(p),
                        //                     };
                        //                     __pro.push(obj);
                        //                 } else {
                        //                     let obj = {
                        //                         // id: res.data[0].id,
                        //                         productCode: p,
                        //                         imageData: null,
                        //                         imagePath: null,
                        //                         imageTitle: "",
                        //                         isCompetitor: comPro.includes(p),
                        //                     };
                        //                     __pro.push(obj);
                        //                 }
                        //             })
                        //             .catch(async (error) => {
                        //                 console.error("Error", error);
                        //                 if (error.response && error.response.data) {
                        //                     setSnackInfo(["error", JSON.stringify(error.response.data)]);
                        //                     setSnackBarOpen(true);
                        //                 } else {
                        //                     setSnackInfo(["error", error.message]);
                        //                     setSnackBarOpen(true);
                        //                 }
                        //             });
                        //     } catch (error) {
                        //         console.error("Error", error);
                        //         if (error.response && error.response.data) {
                        //             setSnackInfo(["error", JSON.stringify(error.response.data)]);
                        //             setSnackBarOpen(true);
                        //         } else {
                        //             setSnackInfo(["error", error.message]);
                        //             setSnackBarOpen(true);
                        //         }
                        //     }
                        // }
                        // setUploadedProducts(__pro);
                        setUploadedProducts(
                            pro.map((datum) => {
                                return {
                                    productCode: datum,
                                    imageData: null,
                                    imagePath: null,
                                    imageTitle: "",
                                };
                            })
                        );
                        setNewCreatedCoreDataId(res.data[0].id);
                        setShowEdit(true);
                    }
                })
                .catch(async (error) => {
                    console.error("Error", error);
                });
        } catch (error) {
            console.error("Error", error);
        } finally{
            setIsLoading(false)
        }
    };

    // handleChange function refactored -- start
    const handleChange = (selected, name) => {
        setIsLoading(true);

        const updatedFilters = {
            ...filters,
            [name]: selected,
        };
        setFilters(updatedFilters);

        const payload = {};
        for (const key in updatedFilters) {
            if (key === "productCategory") {
                payload[key] = `${productCategoryId}`;
            } else {
                payload[key] = updatedFilters[key].map((item) => item.value).join(",");
            }
        }

        const keyToSetterMap = {
            study_type: { setter: setStudyTypeOptionsDataDriven, skipIfName: "studyType" },
            study_type_method: { setter: setStudyTypeMethodOptionsDataDriven, skipIfName: "studyTypeMethod" },
            unilever_brands: { setter: setUnileverBrandOptionsDataDriven, skipIfName: "unileverBrand" },
            competitor_brands: { setter: setCompetitorBrandOptionsDataDriven, skipIfName: "competitorBrand" },
            country: { setter: setCountryOptionsDataDriven, skipIfName: "country" },
            study_period: { setter: setStudyPeriodOptionsDataDriven, skipIfName: "studyPeriod" },
            project_name: { setter: setProjectNameOptionsDataDriven, skipIfName: ["projectName", "studyReference"] },
            study_reference: { setter: setStudyReferenceOptionsDataDriven, skipIfName: ["studyReference", "projectName"] },
            // Uncomment if needed
            // product_category: { setter: setProductCategoryOptionsDataDriven, skipIfName: "productCategory" },
        };

        const url = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/data-filter/`;

        api.post(url, payload)
            .then((res) => {
                if (Object.keys(res.data).length > 0) {
                    for (const key in res.data) {
                        const config = keyToSetterMap[key];
                        if (!config) continue;

                        const skip = Array.isArray(config.skipIfName) ? config.skipIfName.includes(name) : config.skipIfName === name;

                        if (skip && selected.length > 0) continue;
                        const options = res.data[key]?.map((datum) => {
                            if (key === "study_type_method") {
                                return {
                                    value: datum.id,
                                    label: datum.title,
                                    htmlLabel: formatDropdownOption(datum.title, datum.study_type__title),
                                };
                            }
                            return {
                                value: datum.id,
                                label: datum.title,
                            };
                        });
                        if (key === "study_type") {
                            options.sort((a, b) => b.label.localeCompare(a.lable));
                        }

                        config.setter(options);
                    }
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                setErrorMessage(error);
                setErrorDialogueOpen(true);
                console.error(error);
            });
    };

    // handleChange function refactored -- start

    const closeActionStandardModal = (type = "", errorMessage = "") => {
        if (type === "success") {
            setSnackInfo([type, "Action standards submitted for the study"]);
            setSnackBarOpen(true);
            setActionStandardModal(false);
        } else if (type === "close") {
            setActionStandardModal(false);
        } else {
            setSnackInfo(["error", JSON.stringify(errorMessage.response.data)]);
            setSnackBarOpen(true);
        }
    };

    const handleOpenEditModel = () => {
        setTempEditData(JSON.parse(JSON.stringify(editData)));
        setOpenEditModal(true);
    };

    return (
        <>
            {/* {(isLoading || isASPostLoading || isASUpdateLoading) && <Loader message={loaderMessage} />} */}
            {isLoading  && <Loader message={loaderMessage} />}
            {showEdit ? (
                <div style={{ position: "relative", right: "32px" }}>
                    <div className="outlined-vtn-container--data-seeding">
                        <Button
                            size="small"
                            className="custom-btn custom-btn-outlined color-blue"
                            startIcon={<EditIcon />}
                            variant="outlined"
                            onClick={handleOpenEditModel}
                        >
                            Edit
                        </Button>
                    </div>
                </div>
            ) : (
                <div style={{ height: 28.3 }}></div>
            )}
            <div style={{ marginTop: -28.3 }}>
                <form>
                    <div className="row justify-content-md-center mt-0 mb-0 row-cols-5">
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={productImg}
                                        alt={"Product"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Select
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        value={filters.productCategory}
                                        placeholder={"Product Category"}
                                        // isSearchable={true}
                                        // defaultMenuIsOpen={false}
                                        options={productCategoryOptionsDataDriven}
                                        // onChange={(newValue) => handleChange([newValue], "productCategory")}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyTypeImg}
                                        alt={"Study Type"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={ReactSelectStyles}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Study Type"}
                                        key="studyType"
                                        options={studyTypeOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyType")}
                                        value={filters.studyType}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyTypeMethodImg}
                                        alt={"Study Type Method"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Study Type Method"}
                                        key="studyTypeMethod"
                                        options={studyTypeMethodOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyTypeMethod")}
                                        value={filters.studyTypeMethod}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={brandImg}
                                        alt={"Brand"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Unilever Brand"}
                                        key="unileverBrand"
                                        options={unileverBrandOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "unileverBrand")}
                                        value={filters.unileverBrand}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={competitorImg}
                                        alt={"competitor"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown dropdown-first-row"
                                        placeholder={"Benchmark Brand"}
                                        key="competitorBrand"
                                        options={competitorBrandOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "competitorBrand")}
                                        value={filters.competitorBrand}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ marginTop: 30 }}
                        className="row justify-content-md-center mb-0 row-cols-5"
                    >
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={countryImg}
                                        alt={"Country"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown"
                                        placeholder={"Country"}
                                        key="country"
                                        options={countryOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "country")}
                                        value={filters.country}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={productNameImg}
                                        alt={"Product Name"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container">
                                    <Select
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown"
                                        onChange={(e) => handleStudyReference(e, "projectName")}
                                        value={data.projectName}
                                        placeholder={"Project Name"}
                                        options={projectNameOptionsDataDriven}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={studyRefImg}
                                        alt={"Study Reference"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <Select
                                        styles={{ ...ReactSelectStyles, valueContainer: (base) => ({ ...base, flexWrap: "nowrap" }) }}
                                        className="dropdown"
                                        value={data.studyReference}
                                        onChange={(e) => handleStudyReference(e, "studyReference")}
                                        placeholder={"Study Reference"}
                                        options={studyReferenceOptionsDataDriven}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={UploadProductImage}
                                        alt={"SharePoint Link"}
                                    />
                                    {uploadedProducts && (
                                        <ProductMetadataProductsListDialog
                                            productsList={uploadedProducts}
                                            coreDataId={newCreatedCoreDataId}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="dropdown-card box-shadow--cards">
                                <div className="dropdown-cards-image-container">
                                    <img
                                        className="dropdown-card-image"
                                        src={calendarImg}
                                        alt={"Study Period"}
                                    />
                                </div>
                                <div className="dropdown-card-dropdown-container ">
                                    <MultiSelect
                                        styles={ReactSelectStyles}
                                        className="dropdown"
                                        placeholder={"Study Period"}
                                        key="studyPeriod"
                                        options={studyPeriodOptionsDataDriven}
                                        onChange={(newValue) => handleChange(newValue, "studyPeriod")}
                                        value={filters.studyPeriod}
                                        isSelectAll={true}
                                        menuPlacement={"bottom"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{ marginTop: 20 }}
                        className="custom-btn-container custom-btn-center-container mb-0"
                    >
                        <Button
                            size="small"
                            type="reset"
                            style={{
                                width: 185,
                            }}
                            className="custom-btn liner-light-blue-background custom-btn--upload-reset"
                            variant="contained"
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                        <Button
                            size="small"
                            style={{
                                textAlign: "left",
                            }}
                            className={disabledDownload ? "custom-btn custom-btn--upload-reset box-shadow--3" : "custom-btn liner-light-blue-background color-white custom-btn--upload-reset"}
                            endIcon={<CloudDownloadIcon />}
                            variant={disabledDownload ? "outlined" : "contained"}
                            disabled={disabledDownload}
                            onClick={() => {
                                if (coreData.id) {
                                    window.open(process.env.REACT_APP_SERVER_PATH + `/core-data-models/download/?id=${coreData.id}`);
                                }
                            }}
                        >
                            Download Uploaded Study Data
                        </Button>
                        <Button
                            size="small"
                            style={{
                                textAlign: "left",
                            }}
                            className={showActionStandard ? "custom-btn liner-light-blue-background color-white custom-btn--upload-reset" : "custom-btn custom-btn--upload-reset box-shadow--3"}
                            variant={showActionStandard ? "contained" : "outlined"}
                            disabled={!showActionStandard}
                            onClick={() => setActionStandardModal(true)}
                        >
                            Action Standards
                        </Button>
                    </div>
                </form>
            </div>
            {openEditModal && (
                <Dialog
                    maxWidth="xs"
                    fullWidth={true}
                    open={openEditModal}
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        // className="liner-light-blue-background-2"
                    >
                        Edit The Details Below
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 5,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            size="small"
                            onClick={() => {
                                handleStudyReference(data.studyReference, "studyReference");
                                setOpenEditModal(false);
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ fontSize: 12 }}>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="productCategory"
                                className="input-label-dialog"
                            >
                                Product Category:
                            </label>
                            <Select
                                className="dialogue-dropdown"
                                value={editData.productCategory}
                                placeholder={"Product Category"}
                                options={productCategoryOptions}
                                isDisabled={true}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="studyType"
                                className="input-label-dialog"
                            >
                                Study Type:
                            </label>
                            <Select
                                className="dialogue-dropdown"
                                value={editData.studyType}
                                placeholder={"Study Type"}
                                options={studyTypeOptionsDataDriven}
                                isDisabled={true}
                            />
                        </div>

                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="studyTypeMethod"
                                className="input-label-dialog"
                            >
                                Study Type Method:
                            </label>
                            <Select
                                className="dialogue-dropdown"
                                value={editData.studyTypeMethod}
                                placeholder={"Study Type Method"}
                                options={studyTypeMethodOptionsDataDriven}
                                isDisabled={true}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="unileverBrand"
                                className="input-label-dialog"
                            >
                                Unilever Brand:
                            </label>
                            <Creatable
                                className="dialogue-dropdown"
                                name="unileverBrand"
                                value={editData.unileverBrand}
                                placeholder={"Unilever Brand"}
                                isMulti={true}
                                options={unileverBrandOptions}
                                onChange={(newValue) => handleInputChange(newValue, "unileverBrand")}
                                onCreateOption={(newValue) => handleCreateNewOptions(newValue, "unileverBrand")}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="competitorBrand"
                                className="input-label-dialog"
                            >
                                Benchmark Brand:
                            </label>
                            <Creatable
                                className="dialogue-dropdown"
                                name={"competitorBrand"}
                                value={editData.competitorBrand}
                                placeholder={"Benchmark Brand"}
                                onChange={(newValue) => handleInputChange(newValue, "competitorBrand")}
                                onCreateOption={(newValue) => handleCreateNewOptions(newValue, "competitorBrand")}
                                isSearchable={true}
                                isMulti={true}
                                options={competitorBrandOptions}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="country"
                                className="input-label-dialog"
                            >
                                Project name:
                            </label>
                            <input
                                type="text"
                                name="projectNameTitle"
                                className="text-input-dialog"
                                placeholder="Project Name"
                                maxLength={100}
                                value={editData.projectNameTitle}
                                onChange={(e) => handleInputChange(e, "projectNameTitle")}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="studyReference"
                                className="input-label-dialog"
                            >
                                Study Reference:
                            </label>
                            <input
                                type="text"
                                name="studyReferenceTitle"
                                className="text-input-dialog"
                                placeholder="Study Reference "
                                maxLength={100}
                                value={editData.studyReferenceTitle}
                                onChange={(e) => handleInputChange(e, "studyReferenceTitle")}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="sharepointLink"
                                className="input-label-dialog"
                            >
                                Sharepoint Link:
                            </label>
                            <input
                                type="text"
                                name="sharepointLink"
                                className="text-input-dialog"
                                placeholder="SharePoint Link"
                                // disabled
                                value={editData.sharepointLink}
                                onChange={(e) => handleInputChange(e, "sharepointLink")}
                            />
                        </div>
                        <div className="dialogue-input-label-container">
                            <label
                                htmlFor="file"
                                className="input-label-dialog"
                            >
                                Choose File:
                            </label>
                            <div className="custom-file pmd-custom-file-outline">
                                <input
                                    onChange={changeHandler}
                                    type="file"
                                    accept=".xlsx"
                                    className="custom-file-input"
                                    id="customOutlineFile"
                                />
                                <label className="custom-file-label">{title === "" ? "Choose File" : title}</label>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Box
                            className=""
                            sx={{ width: "100%", textAlign: "center", paddingBottom: "5px" }}
                        >
                            <Button
                                size="small"
                                className={disableUpdate ? "custom-btn custom-btn--upload-reset box-shadow--3" : "custom-btn liner-light-blue-background custom-btn--upload-reset"}
                                variant="contained"
                                onClick={(e) => handleSubmit(e)}
                                disabled={disableUpdate}
                            >
                                Update
                            </Button>
                            <Button
                                size="small"
                                className="custom-btn custom-btn--upload-reset"
                                variant="outlined"
                                onClick={() => {
                                    handleStudyReference(data.studyReference, "studyReference");
                                    setOpenEditModal(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>
            )}
            {actionStandardModal && (
                <Dialog
                    maxWidth="xl"
                    fullWidth={true}
                    open={actionStandardModal}
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        // className="liner-light-blue-background-2"
                    >
                        Action Standards
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 5,
                                // fontSize: 10,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            size="small"
                            onClick={() => closeActionStandardModal("close")}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ fontSize: 12 }}>
                        <ActionStandardTabs
                            coreDataId={newCreatedCoreDataId}
                            weighted={coreData.weighted}
                            studyTypeMethod={coreData.study_type_method}
                            closeActionStandardModal={closeActionStandardModal}
                            coreData={coreData}
                            // setIsASUpdateLoading={setIsASUpdateLoading}
                            // setIsASPostLoading={setIsASPostLoading}
                        />
                    </DialogContent>
                </Dialog>
            )}
            <AlertDialogue
                open={successDialogueOpen}
                icon="success"
                title="Success!"
                description="Your data has been updated successfully!"
                buttons={
                    <div>
                        <Button
                            size="small"
                            onClick={handleSuccessClose}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                                // height: 31.6,
                                // textAlign: "left",
                                // lineHeight: "14.5px",
                                // width: "100%",
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            Continue
                        </Button>
                    </div>
                }
            />
            <AlertDialogue
                open={errorDialogueOpen}
                icon="error"
                title="Error!"
                description={errorMessage}
                buttons={
                    <div>
                        <Button
                            size="small"
                            onClick={handleErrorClose}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                                // height: 31.6,
                                // textAlign: "left",
                                // lineHeight: "14.5px",
                                // width: "100%",
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            Go Back
                        </Button>
                        <Button
                            size="small"
                            onClick={handleSanityCheckDialogue}
                            style={{
                                paddingLeft: 10,
                                paddingRight: 10,
                                textTransform: "unset",
                                // height: 31.6,
                                // textAlign: "left",
                                // lineHeight: "14.5px",
                                // width: "100%",
                                marginLeft: 10,
                            }}
                            className="custom-btn-outlined color-blue"
                            variant="outlined"
                        >
                            View Details
                        </Button>
                    </div>
                }
            />

            <SanityCheckDialogue
                open={sanityCheckDialogOpen}
                errors={[...redSanityChecks]}
                warnings={[...yellowSanityChecks]}
                errorMessage="Please resolve errors before moving ahead"
                title="Sanity Check"
                submitButton="Update"
                closeButton="Cancel"
                handleSubmit={handleSanityCheckDialogueUpdateButtonClick}
                handleClose={handleSanityCheckClose}
            />
            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={snackBarOpen}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}
            >
                <Alert
                    onClose={handleSnackBarClose}
                    severity={snackInfo[0]}
                    sx={{
                        maxHeight: 300,
                        maxWidth: 700,
                        width: "100%",
                        overflow: "auto",
                    }}
                >
                    {snackInfo[1]}
                </Alert>
            </Snackbar>
        </>
    );
}

export default UpdateDataSeeding;
